module.exports = __webpack_public_path__ + "static/HEB_pin-8f06b3d8dc3b81d4b1a3cf6845412aa9.png";